import { createContext, useReducer } from 'react';
import transactionsReducer from './transactionsReducer';

export const TransactionsContext = createContext();

const transactionsSectionState = {
    cardTransactions: {
        total: 0,
        results: []
    },
    isSuccessAlertOpen: false,
    isErrorAlertOpen: false,
    shouldUpdateCardTransactionList: false
};

export const TransactionsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(transactionsReducer, transactionsSectionState);

    return <TransactionsContext.Provider value={{ state, dispatch }}>{children}</TransactionsContext.Provider>;
};
